import { render, staticRenderFns } from "./shopline-consent.vue?vue&type=template&id=495d4465&scoped=true&"
import script from "./shopline-consent.vue?vue&type=script&lang=js&"
export * from "./shopline-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d4465",
  null
  
)

export default component.exports